import EpiContext from '@episerver/spa-core/Spa';
import React, {useState, useEffect} from 'react';
import {Form, Col, FormGroup, Input, Label, Row, Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import HeadLineComponent from '../AbroadBusinessIndividualBlock/HeadlineComponent';

import AddOrRemoveImei from './AddOrRemoveImei';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {useDispatch, useSelector} from 'react-redux';
import {setIsIMEIEditMode, setIsImeiChangeSuccsess} from '../PortalsBlock/portalSlice';
import {EditIcon} from './EditIcon';
import ImeiChangeSuccsess from './ImeiChangeSuccsess';

const ClientInformationSuccess = (props) => {
  const portalState = useSelector((state) => state.portalsBlock);
  const dispatch = useDispatch();
  useEffect(() => {
    props.reportDWH('SUCCESS_PAGE', {param10: props.isAllowed.phoneNumber, param2: props.formType, param1: props.selectedHetPay});
  }, []);
  useEffect(() => {}, [portalState.IMEIList]);
  useEffect(() => {
    if (portalState.isIMEIEditMode) {
      setEditClientName(false);
    }
  }, [portalState.isIMEIEditMode]);
  const [showPopUpFail, setShowPopUpFail] = useState(false);
  const [showPopUpAreYouSure, setShowPopUpAreYouSure] = useState(false);

  const [newClientName, setNewClientName] = useState(null);
  const [editClientName, setEditClientName] = useState(false);
  const [saved, setSaved] = useState(false);
  const changeClientName = async () => {
    const res = await props.onSaveNewName(newClientName);
    if (res.payload.isSuccess) {
      setEditClientName(false);
      setNewClientName(false);
      setSaved(true);
      let details = {_subscriber: props.isAllowed.phoneNumber ,'שם מנוי': newClientName?.firstName + ' ' + newClientName?.lastName}

      props.reportDWH('UPDATE_SUCCESS', {
        param10: props.isAllowed.phoneNumber,
        param2: props.formType,
        param1: props.selectedHetPay,
        businessDetails: details,
      });

    } else {
      setSaved(false);
      setShowPopUpFail(true);
      props.reportDWH('UPDATE_FAIL', {
        param10: props.isAllowed.phoneNumber,
        param2: props.formType,
        param1: props.selectedHetPay,
      });
    }
  };
  useEffect(() => {
    if (editClientName) {
      props.reportDWH('UPDATE_DISPLAYED', {
        param10: props.isAllowed.phoneNumber,
        param2: props.formType,
        param1: props.selectedHetPay,
      });
    }
  }, [editClientName]);
  return (
    <>
      {portalState.isImeiChangeSuccsess ? (
        <ImeiChangeSuccsess
          isAdd={portalState.isAddImei}
          isRemove={portalState.isRemoveImei}
          onClick={() => dispatch(setIsImeiChangeSuccsess({success: false}))}
        />
      ) : (
        <div className='client-info-success'>
          <Container fluid className={`mt-3 ${isMobile ? 'w-100' : 'w-25'}`}>
            <HeadLineComponent boldTitle='' title={'פרטי מנוי'} />
            <Form>
              <FormGroup>
                <Label for='phoneNumber'>מספר טלפון</Label>
                <Input disabled defaultValue={props.isAllowed.phoneNumber} />
              </FormGroup>
              <FormGroup className=''>
                {!editClientName ? (
                  <>
                    <Row className='d-flex justify-content-between align-items-center  m-0'>
                      <Label for='clientName'> שם הלקוח</Label>
                      <span
                        style={{marginLeft: '11px', cursor: 'pointer'}}
                        onClick={() => {
                          setEditClientName(true);
                          dispatch(setIsIMEIEditMode(false));
                          props.reportDWH('UPDATE_CLICKED', {
                            param10: props.isAllowed.phoneNumber,
                            param2: props.formType,
                            param1: props.selectedHetPay,
                          });
                        }}>
                        <EditIcon />
                      </span>
                    </Row>
                    <Input
                      disabled={editClientName ? false : true}
                      value={
                        !newClientName && !editClientName
                          ? props.isAllowed.subscriberName
                          : newClientName?.firstName + ' ' + newClientName?.lastName
                      }
                    />
                  </>
                ) : (
                  <div className='full-name-inputs'>
                    <div className='first-name'>
                      <Label for='clientName'> שם פרטי</Label>
                      <Input
                        disabled={editClientName ? false : true}
                        value={newClientName?.firstName}
                        required={true}
                        onChange={(x) => {
                          setNewClientName({
                            ...newClientName,
                            firstName: x.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className='last-name'>
                      <Label for='clientName'> שם משפחה</Label>
                      <Input
                        disabled={editClientName ? false : true}
                        value={newClientName?.lastName}
                        required={true}
                        onChange={(x) => {
                          setNewClientName({
                            ...newClientName,
                            lastName: x.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                )}
              </FormGroup>
              <FormGroup>
                <Label for='banNumber'>מספר לקוח BAN</Label>
                <Input disabled defaultValue={props.isAllowed.customerBan} />
              </FormGroup>
              <FormGroup>
                <Label for='pricePlanDesc'>שם תכנית חיוב הנוכחית</Label>
                <Input disabled defaultValue={props.isAllowed.pricePlanDesc} />
              </FormGroup>
              <FormGroup>
                <Label for='customerSerialNumber'>מספר סים</Label>
                <Input disabled defaultValue={props.isAllowed.customerSerialNumber} />
              </FormGroup>
               <FormGroup>
                <Label for='customerStatus'>סטטוס מנוי</Label>
                <Input disabled defaultValue={portalState.subStatusDesc} />
              </FormGroup>
                <FormGroup>
                <Label for='customerStatus'>סטטוס פיננסי</Label>
                <Input disabled defaultValue={portalState.financialStatusDesc} />
              </FormGroup>
              <FormGroup>
                <AddOrRemoveImei
                  props={props}
                  setShowPopUpFail={setShowPopUpFail}
                  setShowPopUpAreYouSure={setShowPopUpAreYouSure}></AddOrRemoveImei>
              </FormGroup>
            </Form>
            {editClientName && (
              <div className='edit-mode-buttons mt-3'>
                <Col xs='6' className={``}>
                  <BtnWhite
                    isBusiness
                    text={`ביטול`}
                    onclick={() => {
                      editClientName && setNewClientName(null);
                      setEditClientName(false);
                    }}
                  />
                </Col>
                <Col xs='6' className={``}>
                  <BtnSubmit
                    isBusiness
                    disabled={editClientName && newClientName?.firstName && newClientName?.lastName ? false : true}
                    text={`שמירה`}
                    onclick={() => {
                      changeClientName();
                      props.reportDWH('UPDATE_BTN_CLICKED', {
                        param10: props.isAllowed.phoneNumber,
                        param2: props.formType,
                        param1: props.selectedHetPay,
                      });
                    }}
                  />
                </Col>
              </div>
            )}
            <Row className='justify-content-center mt-2'>
              {!props.isIMEIEditMode && (
                <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center back-to-self-care-btn`}>
                  <BtnWhite
                    isBusiness
                    text={`חזרה לאיזור האישי`}
                    onclick={
                      editClientName
                        ? () => {
                            setShowPopUpAreYouSure(true);
                          }
                        : () => {
                            EpiContext.navigateTo(Config.businessLobbyUrl);
                            props.onPopupClosing();
                          }
                    }
                  />
                </Col>
              )}
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default ClientInformationSuccess;
